import React from "react";
import Intro from "../pages/Intro";
import More from "../pages/More";
import Slider from "react-slick";
import { useEffect } from "react";
const HomePage = () => {
  var settings = {
    slidesToShow: 1,
    infinite: false,
    margin: "20px",
  };

  return (
    <>
      {/*
      <section className="flight-seat-selection">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <Slider {...settings}>
                <div className="bg-sky">
                  <ul className="legendWrap">
                    <li className="makeFlex gap-x-15">
                      <span
                        className="box"
                        style={{ backgroundColor: " rgb(80, 227, 194);" }}
                      ></span>
                      <span className="fontSize12">Free</span>
                    </li>
                    <li className="makeFlex gap-x-15">
                      <span
                        className="box"
                        style={{ backgroundColor: " rgb(186, 218, 255);" }}
                      ></span>
                      <span className="fontSize12">₹ 300-500</span>
                    </li>
                    <li className="makeFlex gap-x-15">
                      <span
                        className="box"
                        style={{ backgroundColor: " rgb(201, 186, 255);" }}
                      ></span>
                      <span className="fontSize12">₹ 600</span>
                    </li>
                    <li className="makeFlex gap-x-15">
                      <span className="box">
                        <span className="bgProperties icon21"></span>
                      </span>
                      <span className="fontSize12">Exit Row Seats</span>
                    </li>
                    <li className="makeFlex gap-x-15">
                      <span className="box">
                        <span className="bgProperties icon21"></span>
                      </span>
                      <span className="fontSize12">Non Reclining</span>
                    </li>
                  </ul>
                  <div className="seatHeader">
                    <div>
                      <p className="fontSize16 boldFont mb-0">
                        <b>Ahmedabad → Mumbai</b>
                      </p>
                      <p className="fontSize12 darkText">
                        1 of 1 Seat(s) Selected
                      </p>
                    </div>
                    <div className="makeFlex">
                      <div className="makeFlex hrtlCenter">
                        <span className="pendingTxt"></span>
                      </div>
                    </div>
                  </div>
                  <div className="flightWrap">
                    <div>
                      <span
                        className="bgProperties iconflFront d-block"
                        style={{
                          backgroundImage:
                            "url(" +
                            "https://jsak.mmtcdn.com/flights/assets/media/ic_flightSmallFront.1e0e0ad4.png" +
                            ")",
                        }}
                      ></span>
                    </div>
                    <div className="flightSeatMatrix">
                      <div>
                        <div className="seatRow">
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">A</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">B</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">C</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">D</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">E</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">F</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">7</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">7</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">8</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">8</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">9</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">9</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">10</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">10</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">11</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">11</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">12</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">12</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">13</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">13</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">14</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">14</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">15</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">15</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">16</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">16</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">17</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">17</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">18</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">18</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">19</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">19</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">20</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">20</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">21</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">21</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">22</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">22</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">23</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">23</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">24</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">24</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">25</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">25</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">26</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">26</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">27</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">27</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">28</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">28</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">29</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">29</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <span
                        className="bgProperties iconflTail d-block"
                        style={{
                          backgroundImage:
                            "url(" +
                            "https://jsak.mmtcdn.com/flights/assets/media/ic_flightSmallTail.aa15f774.png" +
                            ")",
                        }}
                      ></span>
                    </div>
                  </div>
                </div>
                <div className="bg-sky">
                  <ul className="legendWrap">
                    <li className="makeFlex gap-x-15">
                      <span
                        className="box"
                        style={{ backgroundColor: " rgb(80, 227, 194);" }}
                      ></span>
                      <span className="fontSize12">Free</span>
                    </li>
                    <li className="makeFlex gap-x-15">
                      <span
                        className="box"
                        style={{ backgroundColor: " rgb(186, 218, 255);" }}
                      ></span>
                      <span className="fontSize12">₹ 300-500</span>
                    </li>
                    <li className="makeFlex gap-x-15">
                      <span
                        className="box"
                        style={{ backgroundColor: " rgb(201, 186, 255);" }}
                      ></span>
                      <span className="fontSize12">₹ 600</span>
                    </li>
                    <li className="makeFlex gap-x-15">
                      <span className="box">
                        <span className="bgProperties icon21"></span>
                      </span>
                      <span className="fontSize12">Exit Row Seats</span>
                    </li>
                    <li className="makeFlex gap-x-15">
                      <span className="box">
                        <span className="bgProperties icon21"></span>
                      </span>
                      <span className="fontSize12">Non Reclining</span>
                    </li>
                  </ul>
                  <div className="seatHeader">
                    <div>
                      <p className="fontSize16 boldFont mb-0">
                        <b>Ahmedabad → Mumbai</b>
                      </p>
                      <p className="fontSize12 darkText">
                        1 of 1 Seat(s) Selected
                      </p>
                    </div>
                    <div className="makeFlex">
                      <div className="makeFlex hrtlCenter">
                        <span className="pendingTxt"></span>
                      </div>
                    </div>
                  </div>
                  <div className="flightWrap">
                    <div>
                      <span
                        className="bgProperties iconflFront d-block"
                        style={{
                          backgroundImage:
                            "url(" +
                            "https://jsak.mmtcdn.com/flights/assets/media/ic_flightSmallFront.1e0e0ad4.png" +
                            ")",
                        }}
                      ></span>
                    </div>
                    <div className="flightSeatMatrix">
                      <div>
                        <div className="seatRow">
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">A</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">B</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">C</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">D</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">E</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatLabel">F</div>
                            </div>
                          </div>
                          <div className="seatCol" style={{ margin: "2.8px;" }}>
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">7</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">7</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">8</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">8</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">9</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">9</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">10</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">10</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">11</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">11</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">12</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">12</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">13</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">13</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">14</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">14</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">15</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">15</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">16</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">16</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">17</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">17</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">18</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">18</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">19</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">19</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">20</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">20</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">21</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">21</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">22</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">22</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">23</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">23</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">24</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">24</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">25</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">25</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">26</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">26</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">27</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">27</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">28</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">28</div>
                            </div>
                          </div>
                        </div>
                        <div className="seatRow">
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">29</div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7B"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7C"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatEmptyLabel"></div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div className="relative">
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7E"
                            >
                              <div className="seatBlock pointer aviabable-st">
                                <span> ₹ 0 </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div
                              className="relative"
                              id="BOM$AUH$2023-01-11 21:30$UK-255_7F"
                            >
                              <div className="seatNotAvailable">
                                <img src="https://imgak.mmtcdn.com/flights/assets/media/dt/ancillaries/seat_not_available.png" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="seatCol"
                            style={{ margin: " 2.8px;" }}
                          >
                            <div>
                              <div className="seatLabel">29</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <span
                        className="bgProperties iconflTail d-block"
                        style={{
                          backgroundImage:
                            "url(" +
                            "https://jsak.mmtcdn.com/flights/assets/media/ic_flightSmallTail.aa15f774.png" +
                            ")",
                        }}
                      ></span>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
            <div className="col-lg-4"></div>
          </div>
        </div>
      </section>
      */}
      <section className="banner-bottom-section mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="banner-bottom-card">
                <div className="icon"></div>
                <div>
                  <h4>Premium Stays</h4>
                  <p>Handpicked Hotels for a luxurious exprience</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="banner-bottom-card">
                <div className="icon"></div>
                <div>
                  <h4>Signature Services</h4>
                  <p>For a perfect stay with exceptional amenities</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="banner-bottom-card">
                <div className="icon"></div>
                <div>
                  <h4>Unmatched Experiences</h4>
                  <p>Curated experiences just for you</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Intro />
      <More />
    </>
  );
};

export default HomePage;
